import * as actions from "store/actions";

const initialState = {
    systemConfiguration: {},
};

const SystemConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SYSTEM_CONFIGURATION_FETCHED_FROM_SERVER:
            return {
                ...state,
                systemConfiguration: action.payload
            };
        case actions.RESET:
            return {
                ...state,
                systemConfiguration: {}
            };
        default:
            return state;
    }
};

export default SystemConfigurationReducer;